import { api } from '@wellesley/openapi'
import { userSlice } from '@wellesley/user/slices/userSlice'
import { getStore } from '@wellesley/store'
import { authSlice } from '../authSlice'
import { authToken } from './token'

export const handleLogout = () => {
  const { dispatch } = getStore()

  dispatch(authSlice.actions.logout())
  dispatch(userSlice.actions.reset())
  dispatch(api.util.resetApiState())
  authToken.removeToken()
}
